import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import GroupsList from './components/GroupsList'
import CreateNewGrpBtn from './components/CreateNewGrpBtn'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@HocDialogComponent
export default class GroupMembersImport extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        groups: IPropTypes.list,
        id: PropTypes.string.isRequired,
        loading: PropTypes.bool,
        manageGroupsDialogCreateNewGroup: PropTypes.func.isRequired,
        manageGroupsDialogInit: PropTypes.func.isRequired,
        settings: PropTypes.object,
        type: PropTypes.string.isRequired,
    }

    static defaultProps = {
        loading: false,
        groups: List(),
    }

    componentDidMount() {
        const { manageGroupsDialogInit, settings } = this.props

        const entities = _.get(settings, 'entities', [])

        manageGroupsDialogInit(entities)
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'close') {
            const { type, closeDialog, id } = this.props

            closeDialog(type, id)
        }
    }

    defineHeader = () => ({
        text: <FormattedMessage id={`${LOCALE_PREFIX}.manageGroupsTitle`} />,
        icon: 'monitoring',
    })

    defineFooter = () => [
        {
            type: 'close',
            text: <FormattedMessage id={`${LOCALE_PREFIX}.close`} />,
        },
    ]

    renderContent = () => {
        const { loading, groups, settings, manageGroupsDialogCreateNewGroup, id, type } = this.props

        if (loading) {
            return (
                <div className={'dialog-loader'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.loadingGroups`} />
                </div>
            )
        }

        return (
            <div className={'dialog-content-container'}>
                <CreateNewGrpBtn
                    id={id}
                    manageGroupsDialogCreateNewGroup={manageGroupsDialogCreateNewGroup}
                    settings={settings}
                    type={type}
                />
                <GroupsList settings={settings} groups={groups} />
            </div>
        )
    }

    render() {
        return <div className={'manage-groups-dialog'}>{this.renderContent()}</div>
    }
}
